module.exports = __webpack_public_path__ + "img/ropbanner.8c0b5185.jpg";